import PubSub from "underpub-js";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

var MotifFlower = function (options) {

  this.options = {
    $el: false,
    baseClass: 'atom-MotifFlower',
  };

  $.extend(true, this.options, options);

};

MotifFlower.prototype.init = function () {

  var self = this;

  self.$icon = self.options.$el.find(`.${self.options.baseClass}__icon`);

  gsap.set(self.$icon, {
    opacity: 1
  })

  PubSub.subscribe('loaded', () => self.initAnimation());

};

MotifFlower.prototype.initAnimation = function () {

  const self = this;

  gsap.from(self.$icon, {
    scale: 0,
    opacity: 0,
    ease: "back.out(1.5)",
    duration: .5,
    delay: .1,
    scrollTrigger: {
      trigger: self.options.$el[0],
      start: "bottom 95%"
    }
  })

  gsap.to(self.$icon, {
    rotation: 360 * 6,
    duration: 1,
    ease: 'none',
    scrollTrigger: {
      trigger: "body",
      scrub: 0.6,
    }
  });
};

export default MotifFlower;